import Heading from '@atlaskit/heading';
import Lozenge from '@atlaskit/lozenge';
import { Box, Flex, Grid, Stack, Text, xcss } from '@atlaskit/primitives';

import rocketImage from '../../../assets/rocket.svg';
import { Capabilities } from '../capabilities';
import { Feedback } from '../feedback';

export const NonProductAdminHomePage = () => {
	return (
		<Grid alignItems="center" templateColumns="1fr">
			<Flex alignItems="center" justifyContent="center">
				<Box xcss={homeWrapperStyles}>
					<Stack space="space.300">
						<Box xcss={suggestionsWrapperStyles}>
							<Box xcss={mainHeadingWrapperStyles}>
								<Stack space="space.150" xcss={mainHeadingStyles}>
									<Flex gap="space.100" alignItems="center">
										<Heading size="xxlarge">Rovo Dev Agents</Heading>
										<Lozenge appearance="inprogress" isBold>
											Beta
										</Lozenge>
									</Flex>

									<Text as="p" testId="non-admin-page-description">
										By tapping into your team’s knowledge in Jira, Confluence, and your codebase,
										Rovo Dev Agents can speed up delivery of high-quality code and let developers
										focus on more meaningful work. Discover more about Rovo Dev Agents
									</Text>
								</Stack>
							</Box>
						</Box>

						<Capabilities integrationsConfigStatesFragment={null} isUserProductAdmin={false} />
						<Feedback />
					</Stack>
				</Box>
			</Flex>
		</Grid>
	);
};

const suggestionsWrapperStyles = xcss({
	paddingTop: 'space.500',
	paddingBottom: 'space.300',
});

const mainHeadingWrapperStyles = xcss({
	'::after': {
		content: '""',
		position: 'absolute',
		top: 'space.0',
		right: 'space.0',
		width: '208px',
		height: '208px',
		background: `url(${rocketImage}) no-repeat`,
	},
	position: 'relative',
});

const mainHeadingStyles = xcss({
	width: 'calc(100% - 250px)',
});

const homeWrapperStyles = xcss({
	paddingTop: 'space.500',
	paddingBottom: 'space.300',
	paddingLeft: 'space.300',
	paddingRight: 'space.300',
});
